<template>
    <header id="header">
        <div class="header-main main cb">
            <router-link class="header-logo-link" to="/"><img class="header-logo" src="https://img.vhiphop.com/web/logo.png" alt="logo"></router-link>
            <!--<div class="slogan">这里有你想看的舞蹈视频</div>-->
            <ul class="header-nav-box fl cb">
                <li class="nav-title-box fl">
                    <router-link to="/" :class="`nav-title${name === 'home' ? ' router-link-active' : ''}`" exact>
                        视频
                    </router-link>
                </li>
                <li class="nav-title-box fl">
                    <router-link to="/contests" :class="`nav-title${name.includes('event') ? ' router-link-active' : ''}`">
                        赛事
                    </router-link>
                </li>
                <li class="nav-title-box fl">
                    <router-link to="/info" :class="`nav-title${name.includes('info') ? ' router-link-active' : ''}`">
                        资讯
                    </router-link>
                </li>
                <li class="nav-title-box fl">
                    <router-link to="/dancers" :class="`nav-title${name.includes('dancer') ? ' router-link-active' : ''}`">
                        舞者
                    </router-link>
                </li>
                <li class="nav-title-box fl">
                    <router-link to="/studios" :class="`nav-title${name.includes('studio') ? ' router-link-active' : ''}`">
                        工作室
                    </router-link>
                </li>
            </ul>


            <ul class="header-user-box fr">
                <li class="header-user-item fl" v-show="name !== 'search'">
                    <div class="header-search-box pr" @click.stop="keywords_show = true">
                        <input v-model="keyword" @keydown.enter="search" class="header-search fl" type="text">
                        <input name="hidden" type="text" style="position:fixed;bottom:-9999px;">
                        <i class="icon-search fr" @click="search"></i>
                        <div class="search-history" v-show="keywords_show && keywords.length">
                            <div class="history-title-box">
                                <div class="history-title">历史搜索</div>
                            </div>

                            <div v-for="v in keywords.slice(0, 5)" class="history-item" @click.stop="searchHistory(v)">
                                <div class="history-text ellipsis">{{v}}</div>
                                <i class="icon-close" @click.stop="clear(v)"></i>
                            </div>

                        </div>
                    </div>
                </li>
                <li class="header-app fl">
                    <router-link to="/app" class="header-app-link">
                        <i class="icon-phone"></i><span class="header-user-text">App下载</span>
                    </router-link>
                    <ul class="header-app-ul">
                        <li class="header-app-list">
                            <a class="header-app-link" href="https://itunes.apple.com/cn/app/vhiphop%E5%94%AF%E8%88%9E/id1104900956?mt=8" target="_blank">
                                <div class="header-app-title">
                                    <span class="header-app-line">| </span>iOS客户端
                                </div>
                                <img class="header-app-img" src="https://img.vhiphop.com/web/ios.png" alt="ios.png">
                            </a>
                        </li>
                        <li class="header-app-list">
                            <a class="header-app-link" href="https://app.xiaomi.com/details?id=com.vhiphop.app" target="_blank">
                                <div class="header-app-title">
                                    <span class="header-app-line">| </span>Android客户端
                                </div>
                                <img class="header-app-img" src="https://img.vhiphop.com/web/android.png" alt="android.png">
                            </a>
                        </li>
                    </ul>
                </li>

                <li class="header-user-item fl" v-if="!user.id">
                    <i class="icon-user"></i><span @click="sign.sign_box_show = sign.is_sign_in = true" class="header-user-text">登录</span>|<span @click="showSignBox" class="header-user-text">注册</span>
                </li>

                <li class="header-user-item fl pr" v-if="user.id">
                        <!--<router-link :to="`/user/${user.id}`" class="header-user-link">
                            <img class="header-user-thumb" :src="user.thumb">
                            {{user.nico}}
                        </router-link>-->
                        <a :href="`/spaces/${user.id}`" class="header-user-link pr z1" target="_blank">
                            <img class="header-user-thumb" :src="user.thumb.replace(/http:/, '')" alt="avatar">
                            {{user.nico}}
                        </a>
                        <!--<a href="javascript:;" class="header-user-link pr z1" target="_blank">
                            <img class="header-user-thumb" :src="user.thumb.replace(/http:/, '')">
                            {{user.nico}}
                        </a>-->
                        <div class="header-user-menu">
                            <ul>
                                <li>
                                    <a :href="`/spaces/${uid}`"  class="user-menu-link" target="_blank">
                                        <i class="icon-home"></i>
                                        个人空间
                                    </a>
                                </li>
                                <li>
                                    <a :href="`/users`"  class="user-menu-link" target="_blank">
                                        <i class="icon-user-center"></i>
                                        个人中心
                                    </a>
                                </li>
                                <li>
                                    <a :href="`/users/manage`"  class="user-menu-link" target="_blank">
                                        <i class="icon-manage"></i>
                                        投稿管理
                                    </a>
                                </li>
                                <li>
                                    <div @click="signOut" class="user-menu-link">
                                        <i class="icon-sign-out"></i>
                                        退出
                                    </div>
                                </li>
                            </ul>
                        </div>

                </li>

                <!--<li class="header-user-item header-upload fl">
                    <i class="icon-upload"></i><span class="header-user-text">投稿</span>
                </li>-->
            </ul>
        </div>
    </header>
</template>

<script>
    export default {
        data: () => ({
            keyword: '',
            keywords_show: false,
        }),
        methods: {
            showSignBox() {
                this.sign.is_sign_in = false;
                this.sign.sign_box_show = true;
            },
            signOut() {// 退出登录
                this.user.id = 0;
                window.localStorage.user = '';// 清空user数据
            },
            search() {
                this.$router.push(`/search?keyword=${this.keyword}`);
                this.keyword = '';
            },
            searchHistory(keyword) {
                this.$router.push(`/search?keyword=${keyword}`);
                this.keywords_show = false;
            },
            clear(keyword) {
                let set = new Set(this.keywords), arr;
                set.delete(keyword);
                arr = Array.from(set);
                this.$store.state.search = arr;
                window.localStorage.search = JSON.stringify(arr);
            },
        },
        computed: {
            user() {
                return this.$store.state.user;
            },
            uid() {
                return this.user.id;
            },
            sign() {
                return this.$store.state.sign;
            },
            keywords() {
                return this.$store.state.search;
            },
            name() {
                return this.$route.name || '';
            }
        },
        mounted() {
            document.onclick = () => {
                this.keywords_show = false;
            }
        }
    }
</script>

<style scoped>
    @import '../../static/css/common/header.css';
    @import '../../static/css/common/search.css';
</style>



// WEBPACK FOOTER //
// src/common/TheHeader.vue